import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id BF55355C-56CC-4C1F-9136-D92AA0800706
 * name tray-plus
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tray-plus.svg
 * tags
 */
export const TrayPlusIcon = createSvgIcon(<><path d="M2 12H4V17H20V12H22V17A2 2 0 0 1 20 19H4A2 2 0 0 1 2 17M11 5H13V8H16V10H13V13H11V10H8V8H11Z" /></>, 'TrayPlusIcon');
export default TrayPlusIcon